import { HorizontalBarItem } from "@common/components/HorizontalBar/HorizontalBar";
import { NetworkHealthStatusDistribution } from "@common/models/Analytics.model";
import { vars } from "@common/styles";

const STATUS_CODE_COLORS: Record<string, string> = {
  "2": "#B77DFF",
  "3": "#C597FF",
  "4": "#D1ACFF",
  "5": "#DABDFF",
  e: "#B77DFF",
  t: "#C597FF",
};

const ERROR_STATUS_CODE_COLORS: Record<string, string> = {
  "2": "#FF453A",
  "3": "#FF6969",
  "4": "#FF9494",
  "5": "#FFBDBD",
  e: "#FF453A",
  t: "#FF6969",
};

export const getStatusColor = (statusClass: string, isError?: boolean): string => {
  const prefix = statusClass.charAt(0);
  const palette = isError ? ERROR_STATUS_CODE_COLORS : STATUS_CODE_COLORS;
  return palette[prefix] ?? vars.colors.grey80;
};

export const toHorizontalBarItems = (data: NetworkHealthStatusDistribution[], isError?: boolean): HorizontalBarItem[] =>
  data.map((d) => ({
    key: d.status_class,
    percentage: d.percentage,
    color: getStatusColor(d.status_class, isError),
    tooltip: `Status ${d.status_class} · ${d.percentage.toFixed(0)}%`,
  }));
